import React from 'react';

const ML_Perceptrons = () => {
    return (
        <div>ML_Perceptrons Component</div>
    );
}

export default ML_Perceptrons;
